import React from "react";
import JalRoLayout from "../components/JalRoLayout";
import {
  AboutContentSection,
  ContactCtaSection,
  PageHero,
  ProcessSection,
  WhyChooseUsSection,
} from "../components/JalRoSections";

const AboutPage = () => (
  <JalRoLayout>
    <PageHero
      title="About Jal RO System"
      text="Experienced RO water purifier technicians serving homes and businesses across Delhi NCR."
    />
    <AboutContentSection />
    <WhyChooseUsSection />
    <ProcessSection />
    <ContactCtaSection />
  </JalRoLayout>
);

export default AboutPage;
